class UserService {

    /**
     * @param $http
     * @param $location
     */
    constructor($http, $window, $location, $q) {
        let self = this;
        this.$http = $http;
        this.$q = $q;
        this.currentUser = null;

        this.delete = function(userId) {
            return self.$http({
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/' + userId,
                data: {}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.sendInvitation = function(email) {
            return self.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/invite',
                data: {email: email}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.saveSmallProfile = function(user) {
            return self.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/' + user.id,
                data: user
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.saveProfile = function(user) {
            return self.$http({
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/' + user.id,
                data: user
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.getMyProfile = function(user) {
            console.log('getMyProfile user');
            var deferred = $q.defer();
            deferred.resolve({platforms: []});
            return deferred.promise;

            // return self.$http({
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/json',
            //         'authentication': localStorage.getItem('kes_token')
            //     },
            //     url: 'api/user/save',
            //     data: {user: user}
            // });
        };

        this.getById = function(id) {
            return self.$http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/' + id,
                data: {}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.list = function(term) {
            return self.$http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/search/' + term,
                data: {}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.hintList = function(term) {
            return self.$http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/hinting/' + term,
                data: {}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.fullList = function() {
            return self.$http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user',
                data: {}
            }).then((response) => response.data).catch((response) => self.$q.reject(response));
        };

        this.loadCurrentUser = function() {
            return self.$http({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token')
                },
                url: 'api/user/current',
                cache: true,
                data: {}
            }).then((response) => {
                self.currentUser = response.data;
                return self.currentUser;
            }).catch((response) => {
                localStorage.removeItem('kes_email');
                localStorage.removeItem('kes_token');
                $window.location.href = '/login';
                return self.$q.reject(response);
            });
        };

        this.isInRole = function(role) {
            let self = this;
            if(self.currentUser) {
                return self.currentUser.roles.includes(role);
            } else {
                return self.loadCurrentUser().then(user => user.roles.includes(role));
            }
        }
    }
}

export default UserService;


// WEBPACK FOOTER //
// ./src/app/pages/user/services/userService.js